// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3Cw3A","messages":"Chat_messages__2Z8Kg","dateDivider":"Chat_dateDivider__1oFbr"};